import { isMailPlusLink, toMpFormLink } from './mailplus'

export namespace DataLayer {
  // ==================
  // | Cookie Consent |
  // ==================

  export const showCookies = () =>
    DatalayerApi.push({
      event: 'noninteraction',
      category: 'cookie consent',
      action: 'cookie permission view',
      label: ''
    })

  export const acceptCookies = () =>
    DatalayerApi.push({
      event: 'interaction',
      category: 'cookie consent',
      action: 'cookie consent accepted',
      label: ''
    })

  export const rejectCookies = () =>
    DatalayerApi.push({
      event: 'interaction',
      category: 'cookie consent',
      action: 'cookie consent declined',
      label: ''
    })

  export const partialAcceptCookies = () =>
    DatalayerApi.push({
      event: 'interaction',
      category: 'cookie consent',
      action: 'cookie consent partially accepted',
      label: ''
    })

  // ===================
  // | Free trial form |
  // ===================

  export const changeTrialFormValue = (
    fieldLabel: string,
    fieldValue?: string
  ) =>
    DatalayerApi.push({
      event: 'interaction',
      category: 'proefperiode flow',
      action: fieldLabel,
      label: fieldValue
    })

  export const errorOnTrialForm = (error: string) =>
    DatalayerApi.push({
      event: 'interaction',
      category: 'proefperiode flow',
      action: 'proefperiode formulier error',
      label: error
    })

  export const successOnTrialForm = (accountType?: 'student' | 'teacher') =>
    DatalayerApi.push({
      event: 'interaction',
      category: accountType ? `${accountType} flow` : 'proefperiode flow',
      action: 'success',
      label: ''
    })

  export const confirmTrial = (accountType?: 'student' | 'teacher') =>
    DatalayerApi.push({
      event: 'interaction',
      category: accountType ? `${accountType} flow` : 'proefperiode flow',
      action: 'proefperiode gestart',
      label: ''
    })

  // ================
  // | Upgrade flow |
  // ================

  export const upgradeFlowStepError = (step: number, error: string) => {
    DatalayerApi.push({
      event: 'interaction',
      category: 'upgrade flow',
      action: `stap ${step} - error`,
      label: error
    })
  }

  export const upgradeFlowChangeStep = (
    currentStep: number,
    buttonText: string,
    action: 'next' | 'back'
  ) => {
    DatalayerApi.push({
      event: 'interaction',
      category: 'upgrade flow',
      action: `stap ${currentStep}`,
      label:
        action == 'next'
          ? buttonText
          : `${buttonText} naar stap ${currentStep - 1}`
    })
  }

  export const upgradeFlowStep1 = (pageload: boolean, frequency?: string) => {
    DatalayerApi.push({
      event: pageload ? 'noninteraction' : 'interaction',
      category: 'upgrade flow',
      action: 'stap 1',
      label: pageload
        ? ''
        : frequency
        ? frequency.includes('Monthly')
          ? 'maandelijks'
          : frequency && frequency.includes('Yearly')
          ? 'jaarlijks'
          : ''
        : ''
    })
  }

  export const upgradeFlowStep2 = (field: string, value?: string) => {
    DatalayerApi.push({
      event: 'interaction',
      category: 'upgrade flow',
      action: `stap 2 - ${field}`,
      label: value
    })
  }

  export const upgradeFlowStep3 = (field: string, value?: string) => {
    DatalayerApi.push({
      event: 'interaction',
      category: 'upgrade flow',
      action: `stap 3 - ${field}`,
      label: value
    })
  }

  export const upgradeFlowSuccessfulPayment = (paymentFrequency: string) => {
    DatalayerApi.push({
      event: 'noninteraction',
      category: 'upgrade flow',
      action: 'stap 4',
      label: `succesvolle upgrade naar ${
        paymentFrequency == 'Monthly' ? 'monthly' : 'yearly'
      } pro-account`
    })
  }

  // =========
  // | Login |
  // =========

  export const changeLoginFormValue = (fieldLabel: string) =>
    DatalayerApi.push({
      event: 'interaction',
      category: 'Account',
      action: 'inloggen',
      label: fieldLabel
    })

  export const clickLoginButton = (buttonText: string) =>
    DatalayerApi.push({
      event: 'interaction',
      category: 'Account',
      action: 'inloggen',
      label: `${buttonText} button`
    })

  export const errorOnLoginForm = (error: string) =>
    DatalayerApi.push({
      event: 'interaction',
      category: 'Account',
      action: 'inloggen',
      label: `login error - ${error}`
    })

  export const successfulLogin = (userId: string) =>
    DatalayerApi.push({
      event: 'noninteraction',
      category: 'Account',
      action: 'Login',
      label: userId
    })

  export const loggedInUserAccountType = (accountType: string) =>
    DatalayerApi.push({
      event: 'interaction',
      category: 'Account',
      action: 'inloggen',
      label: accountType
    })

  export const loggedInUserJobTitle = (
    accountType: string,
    userId: string,
    jobTitle: string
  ) =>
    DatalayerApi.push({
      event: 'loginType',
      loginType: accountType,
      userID: userId,
      'job title': jobTitle
    })

  export const succesfulAccountMigration = () =>
    DatalayerApi.push({
      event: 'interaction',
      category: 'Account',
      action: 'inloggen',
      label: 'migratie account succesvol'
    })

  export const succesfulPasswordChange = () =>
    DatalayerApi.push({
      event: 'interaction',
      category: 'Account',
      action: 'inloggen',
      label: 'nieuw paswoord is opgeslagen'
    })

  // ===========
  // | Paywall |
  // ===========

  export const showPaywall = (action: string) =>
    DatalayerApi.push({
      event: 'noninteraction',
      category: 'paywall',
      action: action,
      label: ''
    })

  // ==============
  // | Every page |
  // ==============

  export const headerButtonsClick = (action: string) =>
    DatalayerApi.push({
      event: 'interaction',
      category: 'button clicks',
      action: action,
      label: ''
    })

  export const pageView = () =>
    DatalayerApi.push({
      event: 'virtualPageview',
      pagepath: window.location.pathname,
      pageUrl: window.location.href,
      pageTitle: 'Gastronomixs'
    })

  export const pageNotFound = () =>
    DatalayerApi.push({
      event: 'pageNotFound',
      pagepath: window.location.pathname,
      pageUrl: window.location.href,
      pageTitle: 'Gastronomixs'
    })

  // ===============
  // | Componenten |
  // ===============

  export const startSaveToCollection = (componentName: string) =>
    DatalayerApi.push({
      event: 'interaction',
      category: 'collectie',
      action: 'start opslaan',
      label: componentName
    })

  export const saveToNewCollection = (componentName: string) =>
    DatalayerApi.push({
      event: 'interaction',
      category: 'collectie',
      action: 'maak een nieuwe collectie',
      label: componentName
    })

  export const saveToExistingCollection = (componentName: string) =>
    DatalayerApi.push({
      event: 'interaction',
      category: 'collectie',
      action: 'component opslaan',
      label: componentName
    })

  export const cancelSaveToCollection = () =>
    DatalayerApi.push({
      event: 'interaction',
      category: 'collectie',
      action: 'opslaan exit'
    })

  export const goToComparableComponent = (componentName: string) =>
    DatalayerApi.push({
      event: 'interaction',
      category: 'collectie',
      action: 'vergelijkbare componenten',
      label: componentName
    })

  export const saveComparableComponent = (componentName: string) =>
    DatalayerApi.push({
      event: 'interaction',
      category: 'collectie',
      action: 'vergelijkbare componenten',
      label: `${componentName} opslaan`
    })

  export const successfulSaveToCollection = (componentName?: string) =>
    DatalayerApi.push({
      event: 'interaction',
      category: 'collectie',
      action: 'component succesvol opgeslagen',
      label: `${componentName} opslaan`
    })

  export const goToCollection = (from: 'component' | 'dashboard') =>
    DatalayerApi.push({
      event: 'interaction',
      category: 'collectie',
      action: 'opgeslagen collectie inzien',
      label: from
    })

  // ==============
  // | Zoekpagina |
  // ==============

  export const noSearchResults = (searchCategory: string, searchTerm: string) =>
    DatalayerApi.push({
      event: 'interaction',
      category: 'zoeken',
      action: `geen resultaat ${searchCategory}`,
      label: searchTerm
    })

  // =====================
  // | Product placement |
  // =====================

  export const loadSponsoredPage = (sponsorName: string) =>
    DatalayerApi.push({
      event: 'noninteraction',
      category: 'productplacement',
      action: sponsorName,
      label: ''
    })

  // ==================
  // | Product kennis |
  // ==================

  export const clickKnowledgeLetter = (knowledgeType: string, letter: string) =>
    DatalayerApi.push({
      event: 'interaction',
      category: knowledgeType,
      action: 'letter select',
      label: letter
    })

  export const clickKnowledgeArticle = (
    knowledgeType: string,
    articleName: string
  ) =>
    DatalayerApi.push({
      event: 'interaction',
      category: knowledgeType,
      label: articleName
    })

  // =====================
  // | Seasonal calendar |
  // =====================

  export const filterSeasonCalendar = (month: string) =>
    DatalayerApi.push({
      event: 'interaction',
      category: 'seizoenskalender',
      action: 'filter op maand',
      label: month
    })

  export const clickIngredientSeasonCalendar = (
    category: string,
    subcategory: string,
    ingredient: string
  ) =>
    DatalayerApi.push({
      event: 'interaction',
      category: 'seizoenskalender',
      action: `${category} - ${subcategory}`,
      label: ingredient
    })

  // =========================
  // | Membership Calculator |
  // =========================

  export const clickMembershipCalculatorEmployeeCount = (
    employeeCount: string
  ) =>
    DatalayerApi.push({
      event: 'event.gtm',
      category: 'clicks_lidmaatschap',
      action: 'click_voordelen',
      label: employeeCount
    })

  // =========================
  // | Magazine Articles      |
  // =========================

  export const magazineArticles = (
    interaction: 'view' | 'click',
    magazine: 'Globe' | 'Logisticx',
    articleTitle: string,
    relevance: 'top1_article' | 'top2_article' | 'row_article' | 'list_article',
  ) =>
    DatalayerApi.push({
      event: 'evo.magazine',
      interaction: interaction,
      page_position: relevance,
      magazine: magazine,
      article_naam: articleTitle
    })

  // =========================
  // | MailPlus               |
  // =========================
  export const mailPlusBrochure = (
    email: string,
    action: string
  ) =>
    DatalayerApi.push({
      event: 'event.evo',
      category: 'brochure',
      email: email,
      action: action
    })

  export const mailPlusAdviseRequest = (
    email: string,
    action: string
  ) =>
    DatalayerApi.push({
      event: 'event.evo',
      category: 'vrijblijvende_adviesaanvraag',
      email: email,
      action: action
    })

  export const mailPlusOptIn = (
    email: string,
    action: string,
    newsletter: string,
    label: string
  ) =>
    DatalayerApi.push({
      event: 'event.evo',
      category: 'EmailOptIn',
      email: email,
      newsletter: newsletter,
      action: action,
      label: label
    })

  export const mailPlusEvent = (
    action: string
  ) =>
    DatalayerApi.push({
      event: 'event.evo',
      category: 'mailplus_form',
      action: action
    })

  // =========================
  // | Course Overview       |
  // =========================
  export const CourseOverviewItemEvent = (
    interaction: 'view' | 'click',
    courseUrl: string,
    courseTitle: string
  ) =>
    DatalayerApi.push({
      event: 'event.evo',
      category: 'item_list',
      action: interaction,
      label: courseUrl,
      name: courseTitle
    })

  export const CourseOverviewSearchEvent = (
    searchPrompt: string,
    selectedFilters: string,
    resultCount: number
  ) =>
    DatalayerApi.push({
      event: 'event.evo',
      category: 'search&filter',
      action: 'search',
      label: searchPrompt,
      results: resultCount,
      filter: selectedFilters,
    })

  export const CourseOverviewFilterEvent = (
    filter: string,
    selectedFilter: string,
    docCount: number
  ) =>
    DatalayerApi.push({
      event: 'event.evo',
      category: 'search&filter',
      action: 'filter',
      label: `${filter} - ${selectedFilter}`,
      results: docCount
    })

  export const CourseOverviewToggleMobileMenu = (
    action: 'open' | 'close',
  ) =>
    DatalayerApi.push({
      event: 'event.evo',
      category: 'search&filter',
      action: `${action}_filter`,
    })

  export namespace DatalayerApi {
    interface DataLayerApi {
      push: (data: {}) => void
    }

    export const push: (data: any) => void = data => {
      const datalayer = window.dataLayer
      if (datalayer) datalayer.push(data)
      else console.log('DataLayer not found, failed to push event', data)
    }
  }
}

// ==========================================================================
// Building blocks
// ==========================================================================

export type GTMEvent = {
  event?: string
  category?: string
  action?: string
  label?: string
}

export const isLinkCTA = (link: string): { result: boolean; type: string } => {
  if (link.startsWith('tel:')) {
    return { result: true, type: 'Telephone' }
  }

  if (link.startsWith('mailto:')) {
    return { result: true, type: 'Email' }
  }

  if (link.includes('/contact')) {
    // Example: use the correct internal contact page path
    return { result: true, type: 'ContactPage' }
  }

  return { result: false, type: '' }
}

export function datalayerHandler(
  type: string,
  action?: string,
  category?: string,
  blockInfo?: {
    kind?: string
    title?: string
    link?: string
    label?: string
  }
): void {
  let datalayer: GTMEvent = {}

  if (blockInfo) {
    datalayer.label = blockInfo.label || blockInfo.link
  }

  if (category !== null) {
    datalayer.category = category
  }

  if (action !== null) {
    datalayer.action = action
  }

  if (
    type === 'text' ||
    type === 'text-image' ||
    type === 'cta' ||
    type === 'quote' ||
    type === 'featured' ||
    type === 'link-grid'
  ) {
    // const linkType = isLinkCTA(blockInfo.link)

    // if (linkType.result === false) return

    datalayer.category = type
    let link = blockInfo?.link
    if (isMailPlusLink(link)) {
      link = toMpFormLink(link)
    }
    datalayer.action = action || link || blockInfo?.title || ''
  }

  // if (type === 'media') {
  //   datalayer.label = blockInfo?.link + ' | ' + window.location.pathname
  // }

  if (datalayer == undefined || JSON.stringify(datalayer) === '{}') return

  DataLayer.DatalayerApi.push({
    // event: datalayer.event ? datalayer.event : `event.${sitename}`, // TODO declare global sitename variable like in public site?
    event: datalayer.event ? datalayer.event : `event.gtm`,
    category: datalayer.category ? datalayer.category : 'BuildingBlock',
    action: datalayer.action ? datalayer.action : 'Click',
    label: datalayer.label ? datalayer.label : window.location.pathname
  })
}

export interface EcommerceItem {
  item_name: string | undefined | null
  item_id: string | undefined
  price: number | undefined
  item_brand: string | undefined
  item_category: string | undefined
  item_category2: string | undefined
  quantity: number | undefined
}

export function ecommerceGA4(
  totalTransaction: number | undefined,
  transactionId: string | undefined,
  items: EcommerceItem[]
) {
  DataLayer.DatalayerApi.push({
    event: 'purchase',
    ecommerce: {
      currency: 'EUR',
      value: totalTransaction,
      transaction_id: transactionId,
      items: items
    }
  })
}

export interface TransactionProduct {
  sku: string | undefined
  name: string | undefined | null
  category: string | undefined
  price: number | undefined
  quantity: number | undefined
}

export function ecommerce(
  transactionId: string | undefined,
  transactionTotal: number | undefined,
  transactionProducts: TransactionProduct[]
) {
  DataLayer.DatalayerApi.push({
    transactionId,
    transactionTotal,
    transactionProducts
  })
}


export type DatalayerEvent = {
  category: string
  action: string
  label?: string
} & OptionalSearchParams &
  OptionalMenuParams &
  OptionalLanguageParams

export type OptionalSearchParams = {
  numberOfResults?: string
}

export type OptionalLanguageParams = {
  language?: string
}

export type OptionalMenuParams = {
  menuType?: 'main' | 'sub' | 'cta' | 'copyright' | 'contact'
}

const defaultParams = {
  event: 'event',
  location: window.location.pathname,
}

export const pushDatalayer = (props: DatalayerEvent) => {
  const params = { ...defaultParams, ...props }
  console.groupCollapsed('pushDatalayer:', params.category)
  console.log(params)
  console.groupEnd()

  if (window.dataLayer) window.dataLayer.push(params)
}
